import { Background } from '../../../atomic/atmosphere/background/Background';
import { Clouds } from '../../../atomic/atmosphere/clouds/Clouds';
import { Shine } from '../../../atomic/atmosphere/shine/Shine';
import { SunBeams } from '../../../atomic/atmosphere/sun_beams/SunBeams';

export type SkyAtmosphereVariant = 'delivery' | 'welcome';

export type SkyAtmosphereProps = {
  variant: SkyAtmosphereVariant;
  sunBeamsClassName?: string;
};

/** Shared sky stack: welcome or delivery atmosphere layers. */
export function SkyAtmosphere({
  variant,
  sunBeamsClassName,
}: SkyAtmosphereProps) {
  if (variant === 'welcome') {
    return (
      <>
        <Background variant="welcome" />
        <Clouds variant="welcome" animation="drift" />
        <Shine variant="welcome" />
      </>
    );
  }

  return (
    <>
      <Background variant="delivery" />
      <Clouds variant="delivery" />
      <Shine variant="delivery" />
      <SunBeams className={sunBeamsClassName} />
    </>
  );
}
